import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSpaInternalNavCapture } from '@/hooks/useSpaInternalNavCapture';
import { Frame, Button } from '@/lib/polaris';
import { XIcon } from '@/lib/polaris-icons';
import { useAuth } from '@smarty/shared';
import { Topbar } from './Topbar';
import { SettingsNav } from './SettingsNav';
import { AdminToastProvider } from '@/contexts/AdminToastContext';
import { storePath } from '@/config/routes.config';
import styles from './SettingsLayout.module.css';

const BODY_ADMIN_CLASS = 'polaris-admin';
const HTML_ADMIN_CLASS = 'polaris-admin-doc';

/**
 * SettingsLayout (Shopify-like)
 * - TopBar + sidebar de Settings (mismo patrón mobile que AppLayout)
 * - polaris-admin en body: evita estilos Tailwind
 */
export function SettingsLayout() {
  const navigate = useNavigate();
  useSpaInternalNavCapture(navigate);
  const { storeSlug } = useAuth();

  useEffect(() => {
    document.documentElement.classList.add(HTML_ADMIN_CLASS);
    document.body.classList.add(BODY_ADMIN_CLASS);
    return () => {
      document.body.classList.remove(BODY_ADMIN_CLASS);
      document.documentElement.classList.remove(HTML_ADMIN_CLASS);
    };
  }, []);

  const handleCloseSettings = () => {
    const lastNonSettings = window.sessionStorage.getItem('smarty:lastNonSettingsLocation');
    // Solo usar última ubicación si existe y no es una ruta de settings (incl. /store/x/settings)
    if (lastNonSettings && !lastNonSettings.includes('/settings')) {
      navigate(lastNonSettings, { replace: true });
      return;
    }
    // Ir al inicio del panel del store (dashboard)
    const homePath = storeSlug ? storePath(storeSlug, '') : '/home';
    navigate(homePath, { replace: true });
  };

  return (
    <Frame topBar={<Topbar onNavigationToggle={() => {}} />}>
      <AdminToastProvider>
        <div style={{ position: 'fixed', top: 'var(--pg-top-bar-height, 4rem)', right: 16, zIndex: 600 }}>
          <Button
            icon={XIcon}
            variant="tertiary"
            accessibilityLabel="Cerrar configuración"
            onClick={handleCloseSettings}
          />
        </div>
        {/* TODO el bloque (menú + contenido) centrado como una unidad, estilo Shopify:
            el nav ya no cuelga del borde izquierdo del Frame; vive dentro de la columna
            centrada junto al contenido. */}
        <div className={styles.center}>
          <aside className={styles.nav}>
            <SettingsNav />
          </aside>
          <div className={styles.content}>
            <Outlet />
          </div>
        </div>
      </AdminToastProvider>
    </Frame>
  );
}

